// ContinuousScanScreen is native-only and not available on web
export default null;
